import React from 'react';

function PriceDisplay({ product }) {
  return (
    <span>
      { product.priceDisplay && <span> |</span> }
      { product.regularPriceDisplay && product.regularPriceDisplay !== product.priceDisplay &&
        <span> <span className="text-light strikethrough">${product.regularPriceDisplay}</span></span> }
      { product.priceDisplay && <span> ${product.priceDisplay}</span> }
    </span>
  )
}

export default PriceDisplay;



// WEBPACK FOOTER //
// ./shared/components/product/priceDisplay.js